import { filter, switchMap, tap } from 'rxjs/operators';
import {
  ErrorHandlerStrategy,
  filterUndefined,
  Professional,
  WebServiceOptions,
  WebServiceSubResourceFetchMode,
} from '@adeo/ngx-kozikaza-api';
import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserStoreService } from '../../../../../shared/services/state-management/user-store.service';
import { KzIconsRegistryService } from '../../../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsLike } from '../../../../../kz-ui/ui/icon/generated-icons/kzIcons-like.icon';
import { ProUsersService } from '../../../../../shared/services/pro/pro-users.service';
import { ProfessionalFavoriteService } from '@adeo/ngx-kozikaza-api/pro/misc';

@Component({
  selector: 'app-pro-favorite',
  templateUrl: './pro-favorite.component.html',
  styleUrls: ['./pro-favorite.component.scss'],
})
export class ProFavoriteComponent implements OnDestroy {
  @Input() pro: Professional;
  @Input() favoriteId: string;
  @Input() miniCover = false;
  @Input() size: 'default' | 'small' = 'default';

  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();

  private postFavoriteSubscription: Subscription;

  constructor(
    public userStoreService: UserStoreService,
    private professionalFavoriteService: ProfessionalFavoriteService,
    protected cdr: ChangeDetectorRef,
    private kzIconsRegistryService: KzIconsRegistryService,
  ) {
    this.kzIconsRegistryService.registerIcons([kzIconsLike]);
  }

  toggleFavorite(): void {
    this.postFavoriteSubscription = ((this.favoriteId) ? this.professionalFavoriteService.deleteProfessionalFavorite({'@id': this.favoriteId}) : this.professionalFavoriteService.postProfessionalFavorite({
      'professional': this.pro['@id']
    }))
      .pipe(
        tap((favoriteCollection) => {
          this.favoriteId = (this.favoriteId) ? null : ((favoriteCollection) ? favoriteCollection['@id'] : null);

          this.refresh.emit(true);

          this.cdr.detectChanges();
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {

    if (this.postFavoriteSubscription && !this.postFavoriteSubscription.closed) {
      this.postFavoriteSubscription.unsubscribe();
    }
  }
}
